export const ACCEPTED_AUDIO = 'audio/mpeg';
export const ACCEPTED_CONTENT =
  'video/quicktime,video/mp4,video/x-msvideo,video/webm,video/x-flv,image/jpeg,image/png,image/bmp,image/webp';
export const ACCEPTED_VIDEO_CONTENT =
  'video/quicktime,video/mp4,video/x-msvideo,video/webm,video/x-flv';
